const useAppleSignIn = ({
  onAppleLogin,
}: {
  onAppleLogin: (token: string, givenName: string, familyName: string) => void;
}) => {
  const signInWithApple = () => {
    if (window.cordova?.plugins?.SignInWithApple) {
      window.cordova.plugins.SignInWithApple.signin(
        {
          requestedScopes: [0, 1], // 0: Email, 1: Full Name (use ASAuthorizationAppleIDRequest.ASAuthorizationScopeEmail if using Ionic Native)
        },
        (success: any) => {
          onAppleLogin(
            success.identityToken,
            success.givenName,
            success.familyName
          );
        },
        (error: any) => {
          console.error("SIWA Error:", JSON.stringify(error));
          // error example: { code: -3, localizedDescription: "Operation failed" }
          alert("Sign-in failed: " + error.localizedDescription);
        }
      );
    } else {
      alert("Plugin not available");
    }
  };

  return signInWithApple;
};

export default useAppleSignIn;
